import { render } from "./AlignHorizontalCenter.vue?vue&type=template&id=1053841c"
import script from "./AlignHorizontalCenter.vue?vue&type=script&lang=js"
export * from "./AlignHorizontalCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlignHorizontalCenter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1053841c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1053841c', __exports__)) {
    api.reload('1053841c', __exports__)
  }
  
  module.hot.accept("./AlignHorizontalCenter.vue?vue&type=template&id=1053841c", () => {
    api.rerender('1053841c', render)
  })

}


export default __exports__